/**
 * @internal
 */
export const primaryLanguage = 'en';
/**
 * @internal
 */
export const translations = ['en', 'de', 'fr', 'fa', 'it', 'uk', 'nl'];
/**
 * @internal
 */
export const translationsPath = 'dist/inpage/i18n/{{lng}}.js';

export * from './translator';
export * from './2sxc.translate';
